import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Umrah from './pages/Umrah';
import Wisata from './pages/Wisata';
import Shop from './pages/Shop';
import Private from './pages/Private';
import Corporate from './pages/Corporate';
import Newsletter from './components/Newsletter';
// Auth pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import RegisterSuccess from './pages/auth/RegisterSuccess';
import ResetSuccess from './pages/auth/ResetSuccess';
// Dashboard pages
import Dashboard from './pages/dashboard/Dashboard';
import ProfileSettings from './pages/dashboard/ProfileSettings';
import DashboardLayout from './components/dashboard/DashboardLayout';
// Tour detail page
import TourDetail from './pages/TourDetail';
// Auth context
import { AuthProvider } from './contexts/AuthContext';
export function App() {
  const [showNewsletter, setShowNewsletter] = useState(false);
  // Show newsletter popup after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowNewsletter(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);
  return <AuthProvider data-id="element-0">
      <Router data-id="element-1">
        <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-2">
          <Routes data-id="element-3">
            {/* Dashboard routes with no header/footer */}
            <Route path="/dashboard" element={<DashboardLayout data-id="element-5" />} data-id="element-4">
              <Route index element={<Dashboard data-id="element-7" />} data-id="element-6" />
              <Route path="settings" element={<ProfileSettings data-id="element-9" />} data-id="element-8" />
              {/* Other dashboard routes would go here */}
            </Route>
            {/* Regular routes with header/footer */}
            <Route path="*" element={<>
                  <Header data-id="element-11" />
                  <main className="flex-grow" data-id="element-12">
                    <Routes data-id="element-13">
                      <Route path="/" element={<Home data-id="element-15" />} data-id="element-14" />
                      <Route path="/about" element={<About data-id="element-17" />} data-id="element-16" />
                      <Route path="/umrah" element={<Umrah data-id="element-19" />} data-id="element-18" />
                      <Route path="/wisata" element={<Wisata data-id="element-21" />} data-id="element-20" />
                      <Route path="/shop" element={<Shop data-id="element-23" />} data-id="element-22" />
                      <Route path="/private" element={<Private data-id="element-25" />} data-id="element-24" />
                      <Route path="/corporate" element={<Corporate data-id="element-27" />} data-id="element-26" />
                      {/* Tour detail page */}
                      <Route path="/tour/:id" element={<TourDetail data-id="element-29" />} data-id="element-28" />
                      {/* Auth routes */}
                      <Route path="/auth/login" element={<Login data-id="element-31" />} data-id="element-30" />
                      <Route path="/auth/register" element={<Register data-id="element-33" />} data-id="element-32" />
                      <Route path="/auth/forgot-password" element={<ForgotPassword data-id="element-35" />} data-id="element-34" />
                      <Route path="/auth/register-success" element={<RegisterSuccess data-id="element-37" />} data-id="element-36" />
                      <Route path="/auth/reset-success" element={<ResetSuccess data-id="element-39" />} data-id="element-38" />
                    </Routes>
                  </main>
                  <Footer data-id="element-40" />
                  {showNewsletter && <Newsletter onClose={() => setShowNewsletter(false)} data-id="element-41" />}
                </>} data-id="element-10" />
          </Routes>
        </div>
      </Router>
    </AuthProvider>;
}